import { BrokerGroupTextField } from '@/admin/brokerGroups/BrokerGroupDrawer/BrokerGroupTextField';
import { Grid, Typography } from '@mui/material';
import React from 'react';

export const LedgerFields = () => {
	return (
		<>
			<Grid size={12}>
				<Typography variant='form_label'>Ledger information</Typography>
			</Grid>
			<BrokerGroupTextField name='ledger' />
			<BrokerGroupTextField name='branchId' sm={6} />
			<BrokerGroupTextField name='permissionsGroup' sm={6} />
		</>
	);
};
